/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_New_Event_Group_ModalInputs */



/**
* | output |
* | --- |
* | "Close new event group modal" |
*
* @param {Close_New_Event_Group_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_new_event_group_modal = /** @type {((inputs?: Close_New_Event_Group_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_New_Event_Group_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre de nouveau groupe d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließen des Modals für neue Ereignisgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la nuova finestra modale del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно новой группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el nuevo grupo de eventos modal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭新建事件组模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントグループモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नए इवेंट समूह मॉडल को बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de novo grupo de eventos")
	return /** @type {LocalizedString} */ ("Close new event group modal")
});